import script from "./CustomerShareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerShareModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomerShareModal.vue?vue&type=style&index=0&id=54166ef4&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54166ef4"]])

export default __exports__